import {
  CategoriesTree,
  CategoriesTreeItem,
} from "../../controller/state/categories"

const expandNodes = (node: CategoriesTreeItem): CategoriesTreeItem[] => {
  const nodes: CategoriesTreeItem[] = [node]
  for (const child of node.children) {
    nodes.push(...expandNodes(child))
  }
  return nodes
}

const expandTreeNodes = (tree: CategoriesTree): CategoriesTreeItem[] => {
  const nodes: CategoriesTreeItem[] = []
  for (const root of tree.root) {
    nodes.push(...expandNodes(root))
  }
  return nodes
}

const getParentNode = (
  node: CategoriesTreeItem,
  allNodes: CategoriesTreeItem[]
) =>
  node.parentCode ? allNodes.find((x) => x.code === node.parentCode) : undefined

const isRootSelectedNode = (
  node: CategoriesTreeItem,
  allNodes: CategoriesTreeItem[]
): boolean => {
  if (!node.checked && !node.allEnabledChildrenChecked) {
    return false
  }

  const parent = getParentNode(node, allNodes)
  if (parent && parent.allEnabledChildrenChecked) {
    return false
  }

  return true
}

export const getSelectedCategories = (
  tree: CategoriesTree
): CategoriesTreeItem[] => {
  const nodes = expandTreeNodes(tree)
  return nodes.filter((x) => isRootSelectedNode(x, nodes))
}
